module.exports = __webpack_public_path__ + "school/img/practiceSeparateCultureArtBg.78ee045b.jpg";